// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { TaskCatalogPageMetadata_RegionFragmentDoc } from '../TaskCatalogPage.generated';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { TaskFilterOptionsFragmentDoc, InternalUserDetailFragmentDoc, DocumentDetailFragmentDoc, BillStatusAndTypeFragmentDoc, ApprovalStatusFragmentDoc, DocumentEditorDetailFragmentDoc, ScheduleTaskInfoFragmentDoc, NamedDevelopmentCohortsProjectsFragmentDoc, DocumentDetailDocumentTypeFragmentDoc } from '../../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskCatalogFormQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TaskCatalogFormQuery = { __typename?: 'Query', globalPlanTask: { __typename?: 'GlobalPlanTask', id: string, name: string, externalName?: string | null | undefined, description: string, optimisticDurationInDays: number, expectedDurationInDays: number, pessimisticDurationInDays: number, applyToAllSchedules: boolean, stage?: { __typename?: 'GlobalPlanStage', id: string, name: string } | null | undefined, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, projectRole?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined, allowances: Array<{ __typename?: 'GlobalPlanAllowance', id: string, constraintItem: { __typename?: 'GlobalPlanConstraintItem', id: string, name: string } }>, constraints: Array<{ __typename?: 'GlobalPlanConstraint', id: string, constraintItem: { __typename?: 'GlobalPlanConstraintItem', id: string, name: string } }>, tags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }>, scopes: Array<{ __typename?: 'GlobalPlanTaskScope', id: string, target: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } }>, budgetItem: { __typename?: 'Item', id: string, name: string }, parent?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, checklistItems: Array<{ __typename?: 'GlobalPlanTaskChecklistItem', id: string, name: string }>, globalRequiredTaskDocuments: Array<{ __typename?: 'GlobalRequiredTaskDocument', id: string, name: string, watchers: Array<Types.ProjectRole>, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string } }>, itemPlanTaskMappings: Array<{ __typename?: 'ItemPlanTaskMapping', id: string, estimatedLaborCostInCents?: number | null | undefined, item: { __typename?: 'Item', id: string }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string } | null | undefined }>, variants: Array<{ __typename?: 'GlobalPlanTaskVariant', id: string, name?: string | null | undefined, optimisticDurationInDays?: number | null | undefined, expectedDurationInDays?: number | null | undefined, pessimisticDurationInDays?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, allowances: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, stage?: { __typename?: 'GlobalPlanStage', id: string } | null | undefined }> } };

export type TaskCatalogFormDropdownQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TaskCatalogFormDropdownQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', businessFunctionType: Array<{ __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }> }, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }>, globalPlanTags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }>, regions: Array<{ __typename?: 'Region', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string, communitites: Array<{ __typename?: 'Community', id: string, name: string, subdivisions: Array<{ __typename?: 'Subdivision', id: string, name: string }> }> }> }>, items: Array<{ __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string } }> };

export type TaskCatalogFormParentDropdownQueryVariables = Types.Exact<{
  filter: Types.GlobalPlanTaskFilter;
}>;


export type TaskCatalogFormParentDropdownQuery = { __typename?: 'Query', globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string, name: string, parent?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined }> } };

export type TaskCatalogFormSchedulingDropdownQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TaskCatalogFormSchedulingDropdownQuery = { __typename?: 'Query', globalPlanConstraintItems: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string, name: string }>, globalPlanStages: Array<{ __typename?: 'GlobalPlanStage', id: string, name: string }>, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string, parent?: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } | null | undefined } | { __typename?: 'Region', id: string, name: string, parent?: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } } | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } } | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } } | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } } | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } } | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }> };

export type TaskCatalogFormSchedulingDropdownProject_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, parent?: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } | null | undefined };

export type TaskCatalogFormSchedulingDropdownProject_Region_Fragment = { __typename?: 'Region', id: string, name: string, parent?: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } | null | undefined };

export type TaskCatalogFormSchedulingDropdownProject_Market_Fragment = { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } };

export type TaskCatalogFormSchedulingDropdownProject_Community_Fragment = { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } };

export type TaskCatalogFormSchedulingDropdownProject_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } };

export type TaskCatalogFormSchedulingDropdownProject_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } };

export type TaskCatalogFormSchedulingDropdownProject_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } };

export type TaskCatalogFormSchedulingDropdownProject_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } };

export type TaskCatalogFormSchedulingDropdownProjectFragment = TaskCatalogFormSchedulingDropdownProject_StandaloneProject_Fragment | TaskCatalogFormSchedulingDropdownProject_Region_Fragment | TaskCatalogFormSchedulingDropdownProject_Market_Fragment | TaskCatalogFormSchedulingDropdownProject_Community_Fragment | TaskCatalogFormSchedulingDropdownProject_Subdivision_Fragment | TaskCatalogFormSchedulingDropdownProject_Lot_Fragment | TaskCatalogFormSchedulingDropdownProject_Structure_Fragment | TaskCatalogFormSchedulingDropdownProject_Unit_Fragment;

export type TaskCatalogFormDocumentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TaskCatalogFormDocumentsQuery = { __typename?: 'Query', documentTypes: Array<{ __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }> };

export type SaveGlobalPlanTaskMutationVariables = Types.Exact<{
  input: Types.SaveGlobalPlanTaskInput;
}>;


export type SaveGlobalPlanTaskMutation = { __typename?: 'Mutation', saveGlobalPlanTask: { __typename?: 'SaveGlobalPlanTaskResult', globalPlanTask: { __typename?: 'GlobalPlanTask', id: string } } };

export type TaskCatalogForm_GlobalPlanTaskFragment = { __typename?: 'GlobalPlanTask', id: string, name: string, externalName?: string | null | undefined, description: string, optimisticDurationInDays: number, expectedDurationInDays: number, pessimisticDurationInDays: number, applyToAllSchedules: boolean, stage?: { __typename?: 'GlobalPlanStage', id: string, name: string } | null | undefined, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, projectRole?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined, allowances: Array<{ __typename?: 'GlobalPlanAllowance', id: string, constraintItem: { __typename?: 'GlobalPlanConstraintItem', id: string, name: string } }>, constraints: Array<{ __typename?: 'GlobalPlanConstraint', id: string, constraintItem: { __typename?: 'GlobalPlanConstraintItem', id: string, name: string } }>, tags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }>, scopes: Array<{ __typename?: 'GlobalPlanTaskScope', id: string, target: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } }>, budgetItem: { __typename?: 'Item', id: string, name: string }, parent?: { __typename?: 'GlobalPlanTask', id: string } | null | undefined, checklistItems: Array<{ __typename?: 'GlobalPlanTaskChecklistItem', id: string, name: string }>, globalRequiredTaskDocuments: Array<{ __typename?: 'GlobalRequiredTaskDocument', id: string, name: string, watchers: Array<Types.ProjectRole>, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string } }>, itemPlanTaskMappings: Array<{ __typename?: 'ItemPlanTaskMapping', id: string, estimatedLaborCostInCents?: number | null | undefined, item: { __typename?: 'Item', id: string }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string } | null | undefined }>, variants: Array<{ __typename?: 'GlobalPlanTaskVariant', id: string, name?: string | null | undefined, optimisticDurationInDays?: number | null | undefined, expectedDurationInDays?: number | null | undefined, pessimisticDurationInDays?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, allowances: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, stage?: { __typename?: 'GlobalPlanStage', id: string } | null | undefined }> };

export type TaskCatalogFormVariant_GlobalPlanTaskVariantFragment = { __typename?: 'GlobalPlanTaskVariant', id: string, name?: string | null | undefined, optimisticDurationInDays?: number | null | undefined, expectedDurationInDays?: number | null | undefined, pessimisticDurationInDays?: number | null | undefined, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, allowances: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, stage?: { __typename?: 'GlobalPlanStage', id: string } | null | undefined };

export type TaskCatalogForm_ChecklistItemFragment = { __typename?: 'GlobalPlanTaskChecklistItem', id: string, name: string };

export type TaskCatalogForm_GlobalRequiredTaskDocumentsFragment = { __typename?: 'GlobalRequiredTaskDocument', id: string, name: string, watchers: Array<Types.ProjectRole>, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string } };

export type TaskCatalogForm_ItemPlanTaskMappingFragment = { __typename?: 'ItemPlanTaskMapping', id: string, estimatedLaborCostInCents?: number | null | undefined, item: { __typename?: 'Item', id: string }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string } | null | undefined };

export const TaskCatalogFormSchedulingDropdownProjectFragmentDoc = gql`
    fragment TaskCatalogFormSchedulingDropdownProject on Project {
  ...Named
  parent {
    id
  }
}
    ${NamedFragmentDoc}`;
export const TaskCatalogForm_ChecklistItemFragmentDoc = gql`
    fragment TaskCatalogForm_ChecklistItem on GlobalPlanTaskChecklistItem {
  id
  name
}
    `;
export const TaskCatalogForm_GlobalRequiredTaskDocumentsFragmentDoc = gql`
    fragment TaskCatalogForm_GlobalRequiredTaskDocuments on GlobalRequiredTaskDocument {
  id
  name
  documentType {
    code
    name
  }
  watchers
}
    `;
export const TaskCatalogForm_ItemPlanTaskMappingFragmentDoc = gql`
    fragment TaskCatalogForm_ItemPlanTaskMapping on ItemPlanTaskMapping {
  id
  item {
    id
  }
  unitOfMeasure {
    id
  }
  estimatedLaborCostInCents
}
    `;
export const TaskCatalogFormVariant_GlobalPlanTaskVariantFragmentDoc = gql`
    fragment TaskCatalogFormVariant_GlobalPlanTaskVariant on GlobalPlanTaskVariant {
  id
  name
  project {
    ...Named
  }
  optimisticDurationInDays
  expectedDurationInDays
  pessimisticDurationInDays
  constraints {
    id
  }
  allowances {
    id
  }
  stage {
    id
  }
}
    ${NamedFragmentDoc}`;
export const TaskCatalogForm_GlobalPlanTaskFragmentDoc = gql`
    fragment TaskCatalogForm_GlobalPlanTask on GlobalPlanTask {
  id
  name
  externalName
  description
  stage {
    id
    name
  }
  optimisticDurationInDays
  expectedDurationInDays
  pessimisticDurationInDays
  businessFunctionType {
    code
    name
  }
  projectRole {
    code
    name
  }
  tradeCategory {
    id
    name
  }
  allowances {
    id
    constraintItem {
      id
      name
    }
  }
  constraints {
    id
    constraintItem {
      id
      name
    }
  }
  tags {
    id
    name
  }
  scopes {
    id
    target {
      ... on Named {
        id
        name
      }
    }
  }
  applyToAllSchedules
  budgetItem {
    id
    name
  }
  parent {
    id
  }
  checklistItems {
    ...TaskCatalogForm_ChecklistItem
  }
  globalRequiredTaskDocuments {
    ...TaskCatalogForm_GlobalRequiredTaskDocuments
  }
  itemPlanTaskMappings {
    ...TaskCatalogForm_ItemPlanTaskMapping
  }
  variants {
    ...TaskCatalogFormVariant_GlobalPlanTaskVariant
  }
}
    ${TaskCatalogForm_ChecklistItemFragmentDoc}
${TaskCatalogForm_GlobalRequiredTaskDocumentsFragmentDoc}
${TaskCatalogForm_ItemPlanTaskMappingFragmentDoc}
${TaskCatalogFormVariant_GlobalPlanTaskVariantFragmentDoc}`;
export const TaskCatalogFormDocument = gql`
    query TaskCatalogForm($id: ID!) {
  globalPlanTask(id: $id) {
    ...TaskCatalogForm_GlobalPlanTask
  }
}
    ${TaskCatalogForm_GlobalPlanTaskFragmentDoc}`;

/**
 * __useTaskCatalogFormQuery__
 *
 * To run a query within a React component, call `useTaskCatalogFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskCatalogFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCatalogFormQuery, TaskCatalogFormQueryVariables> & ({ variables: TaskCatalogFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>(TaskCatalogFormDocument, options);
      }
export function useTaskCatalogFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>(TaskCatalogFormDocument, options);
        }
// @ts-ignore
export function useTaskCatalogFormSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>;
export function useTaskCatalogFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormQuery | undefined, TaskCatalogFormQueryVariables>;
export function useTaskCatalogFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>(TaskCatalogFormDocument, options);
        }
export type TaskCatalogFormQueryHookResult = ReturnType<typeof useTaskCatalogFormQuery>;
export type TaskCatalogFormLazyQueryHookResult = ReturnType<typeof useTaskCatalogFormLazyQuery>;
export type TaskCatalogFormSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogFormSuspenseQuery>;
export type TaskCatalogFormQueryResult = Apollo.QueryResult<TaskCatalogFormQuery, TaskCatalogFormQueryVariables>;
export const TaskCatalogFormDropdownDocument = gql`
    query TaskCatalogFormDropdown {
  enumDetails {
    businessFunctionType {
      code
      name
    }
  }
  tradeCategories {
    id
    name
  }
  globalPlanTags {
    id
    name
  }
  regions {
    ...TaskCatalogPageMetadata_Region
  }
  items(filter: {version: [2]}) {
    id
    name
    costCode {
      id
    }
  }
}
    ${TaskCatalogPageMetadata_RegionFragmentDoc}`;

/**
 * __useTaskCatalogFormDropdownQuery__
 *
 * To run a query within a React component, call `useTaskCatalogFormDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogFormDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogFormDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCatalogFormDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>(TaskCatalogFormDropdownDocument, options);
      }
export function useTaskCatalogFormDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>(TaskCatalogFormDropdownDocument, options);
        }
// @ts-ignore
export function useTaskCatalogFormDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>;
export function useTaskCatalogFormDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormDropdownQuery | undefined, TaskCatalogFormDropdownQueryVariables>;
export function useTaskCatalogFormDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>(TaskCatalogFormDropdownDocument, options);
        }
export type TaskCatalogFormDropdownQueryHookResult = ReturnType<typeof useTaskCatalogFormDropdownQuery>;
export type TaskCatalogFormDropdownLazyQueryHookResult = ReturnType<typeof useTaskCatalogFormDropdownLazyQuery>;
export type TaskCatalogFormDropdownSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogFormDropdownSuspenseQuery>;
export type TaskCatalogFormDropdownQueryResult = Apollo.QueryResult<TaskCatalogFormDropdownQuery, TaskCatalogFormDropdownQueryVariables>;
export const TaskCatalogFormParentDropdownDocument = gql`
    query TaskCatalogFormParentDropdown($filter: GlobalPlanTaskFilter!) {
  globalPlanTasks(filter: $filter) {
    entities {
      id
      name
      parent {
        id
      }
    }
  }
}
    `;

/**
 * __useTaskCatalogFormParentDropdownQuery__
 *
 * To run a query within a React component, call `useTaskCatalogFormParentDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogFormParentDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogFormParentDropdownQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTaskCatalogFormParentDropdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables> & ({ variables: TaskCatalogFormParentDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>(TaskCatalogFormParentDropdownDocument, options);
      }
export function useTaskCatalogFormParentDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>(TaskCatalogFormParentDropdownDocument, options);
        }
// @ts-ignore
export function useTaskCatalogFormParentDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>;
export function useTaskCatalogFormParentDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormParentDropdownQuery | undefined, TaskCatalogFormParentDropdownQueryVariables>;
export function useTaskCatalogFormParentDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>(TaskCatalogFormParentDropdownDocument, options);
        }
export type TaskCatalogFormParentDropdownQueryHookResult = ReturnType<typeof useTaskCatalogFormParentDropdownQuery>;
export type TaskCatalogFormParentDropdownLazyQueryHookResult = ReturnType<typeof useTaskCatalogFormParentDropdownLazyQuery>;
export type TaskCatalogFormParentDropdownSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogFormParentDropdownSuspenseQuery>;
export type TaskCatalogFormParentDropdownQueryResult = Apollo.QueryResult<TaskCatalogFormParentDropdownQuery, TaskCatalogFormParentDropdownQueryVariables>;
export const TaskCatalogFormSchedulingDropdownDocument = gql`
    query TaskCatalogFormSchedulingDropdown {
  globalPlanConstraintItems {
    id
    name
  }
  globalPlanStages {
    id
    name
  }
  projects(filter: {type: [Region, Market, Community, Subdivision]}) {
    ...TaskCatalogFormSchedulingDropdownProject
  }
}
    ${TaskCatalogFormSchedulingDropdownProjectFragmentDoc}`;

/**
 * __useTaskCatalogFormSchedulingDropdownQuery__
 *
 * To run a query within a React component, call `useTaskCatalogFormSchedulingDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogFormSchedulingDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogFormSchedulingDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCatalogFormSchedulingDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>(TaskCatalogFormSchedulingDropdownDocument, options);
      }
export function useTaskCatalogFormSchedulingDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>(TaskCatalogFormSchedulingDropdownDocument, options);
        }
// @ts-ignore
export function useTaskCatalogFormSchedulingDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>;
export function useTaskCatalogFormSchedulingDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormSchedulingDropdownQuery | undefined, TaskCatalogFormSchedulingDropdownQueryVariables>;
export function useTaskCatalogFormSchedulingDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>(TaskCatalogFormSchedulingDropdownDocument, options);
        }
export type TaskCatalogFormSchedulingDropdownQueryHookResult = ReturnType<typeof useTaskCatalogFormSchedulingDropdownQuery>;
export type TaskCatalogFormSchedulingDropdownLazyQueryHookResult = ReturnType<typeof useTaskCatalogFormSchedulingDropdownLazyQuery>;
export type TaskCatalogFormSchedulingDropdownSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogFormSchedulingDropdownSuspenseQuery>;
export type TaskCatalogFormSchedulingDropdownQueryResult = Apollo.QueryResult<TaskCatalogFormSchedulingDropdownQuery, TaskCatalogFormSchedulingDropdownQueryVariables>;
export const TaskCatalogFormDocumentsDocument = gql`
    query TaskCatalogFormDocuments {
  documentTypes {
    ...DocumentDetailDocumentType
  }
}
    ${DocumentDetailDocumentTypeFragmentDoc}`;

/**
 * __useTaskCatalogFormDocumentsQuery__
 *
 * To run a query within a React component, call `useTaskCatalogFormDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogFormDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogFormDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCatalogFormDocumentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>(TaskCatalogFormDocumentsDocument, options);
      }
export function useTaskCatalogFormDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>(TaskCatalogFormDocumentsDocument, options);
        }
// @ts-ignore
export function useTaskCatalogFormDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>;
export function useTaskCatalogFormDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogFormDocumentsQuery | undefined, TaskCatalogFormDocumentsQueryVariables>;
export function useTaskCatalogFormDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>(TaskCatalogFormDocumentsDocument, options);
        }
export type TaskCatalogFormDocumentsQueryHookResult = ReturnType<typeof useTaskCatalogFormDocumentsQuery>;
export type TaskCatalogFormDocumentsLazyQueryHookResult = ReturnType<typeof useTaskCatalogFormDocumentsLazyQuery>;
export type TaskCatalogFormDocumentsSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogFormDocumentsSuspenseQuery>;
export type TaskCatalogFormDocumentsQueryResult = Apollo.QueryResult<TaskCatalogFormDocumentsQuery, TaskCatalogFormDocumentsQueryVariables>;
export const SaveGlobalPlanTaskDocument = gql`
    mutation SaveGlobalPlanTask($input: SaveGlobalPlanTaskInput!) {
  saveGlobalPlanTask(input: $input) {
    globalPlanTask {
      id
    }
  }
}
    `;
export type SaveGlobalPlanTaskMutationFn = Apollo.MutationFunction<SaveGlobalPlanTaskMutation, SaveGlobalPlanTaskMutationVariables>;

/**
 * __useSaveGlobalPlanTaskMutation__
 *
 * To run a mutation, you first call `useSaveGlobalPlanTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalPlanTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalPlanTaskMutation, { data, loading, error }] = useSaveGlobalPlanTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalPlanTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalPlanTaskMutation, SaveGlobalPlanTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalPlanTaskMutation, SaveGlobalPlanTaskMutationVariables>(SaveGlobalPlanTaskDocument, options);
      }
export type SaveGlobalPlanTaskMutationHookResult = ReturnType<typeof useSaveGlobalPlanTaskMutation>;
export type SaveGlobalPlanTaskMutationResult = Apollo.MutationResult<SaveGlobalPlanTaskMutation>;
export type SaveGlobalPlanTaskMutationOptions = Apollo.BaseMutationOptions<SaveGlobalPlanTaskMutation, SaveGlobalPlanTaskMutationVariables>;